<template>
  <div :class="['navT', $isSdk() && 'navT-sdk']" :style="{
    background,
    paddingTop: ispt && statusBarHeight + 'px'
  }">
    <div v-if="isHistory" class="nav-left" @click.stop="handleBack">
      <van-icon name="arrow-left" />
    </div>
    <div v-if="isBack" class="nav-left">
      <slot name="left"></slot>
    </div>
    <div class="nav-title">
      <img v-if="icon" :src="icon" alt="" class="icon_img">
      <slot>
        <span>{{ title }}</span>
      </slot>
    </div>
    <div class="nav-right">
      <slot name="right">
        <template>
          <div class="kf" v-if="kf" @click.stop="$emit('kf')">
            <img class="img" src="@/assets/image/user/orderKf.png" mode="widthFix"></img>
            <span>客服</span>
          </div>
          <div class="right" @click="clickRight">{{ right }}</div>
        </template>
      </slot>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    title: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: '#fff'
    },
    icon: {
      type: String,
      default: ''
    },
    clickLeft: {
      type: Function,
      default: null
    },
    isHistory: {
      type: Boolean,
      default: true
    },
    right: {
      type: String,
      default: "",
    },
    //是否显示客服按钮
    kf: {
      type: Boolean,
      default: false,
    },
    // 是否自定义返回按钮
    isBack: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    statusBarHeight() {
      return this.$store.state.statusBarHeight;
    },
    ispt() {
      return this.$isApp() && this.$store.state.isFullScreen;
    }
  },

  data() {
    return {};
  },

  methods: {
    handleBack() {
      if (this.clickLeft) {
        this.clickLeft();
        return;
      }
      if (window.history.length <= 1) {
        this.$router.replace('/pages/index/index');
      } else {
        this.$router.back();
      }
    },
    clickRight() {
      console.log(22222222);
      this.$emit("clickRight");
    },
  }
};
</script>

<style lang="scss" scoped>
.navT {
  min-height: 2.2rem;
  display: flex;
  align-items: center;
  padding: 0 .6rem;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;

  .kf {
    position: absolute;
    top: 50%;
    right: 1.5rem;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    font-size: 0.7rem;
    color: #1D1D1D;
    // margin-right: 1rem;

    .img {
      display: block;
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.4rem;
    }
  }

  .nav-left {
    width: 1.2rem;
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    cursor: pointer;

    .iconfont {
      font-size: 1rem;
      color: #333;
    }

    .van-icon {
      font-size: 1rem !important;
    }
  }

  .nav-title {
    flex: 1;
    text-align: center;
    font-size: .8rem;
    font-weight: 700;
    color: #000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-right {
    min-width: 1.2rem;
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .icon_img {
    width: 1.4rem;
    height: 1.4rem;
    margin-right: .3rem;
  }

}
</style>